export const highlightMatch = ({ text, query }: { text: string; query: string }): string => {
  if (!query) return text;

  // Escape special characters in the query to avoid issues in the regex
  const escapedQuery = query.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");

  // Create a case-insensitive regular expression to match the query
  const regex = new RegExp(`(${escapedQuery})`, "gi");

  // Replace the matched text with the <mark> tag
  return text.replace(regex, "<b>$1</b>");
};
